import { Badge, Card, Col, Drawer, Popover, Row, Typography } from "antd";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { AlertC, EmptyC, IconC, ToolTipC } from "src/shared/components";
import useDirection from "src/shared/hooks/useDirection";
import useRequest from "src/shared/hooks/useRequest";
import useSse from "src/shared/hooks/useSse";
import bell from "src/shared/assets/svg/icon/bell.svg";
import useAuth from "src/shared/hooks/useAuth";
import { useHistory } from "react-router-dom";
import { BASE_URL } from "src/ApiCall/BaseUrl";
import "./index.less";
const NotificationsHeader = () => {
  const { t } = useTranslation();
  const { styler } = useDirection();
  const { onEdit, loading } = useRequest();
  const { isLogedIn, decode } = useAuth();
  const { push } = useHistory();
  const [visible, setVisible] = useState(false);

  const [notificationReadIds, setNotificationReadIds] = useState<number[]>([]);
  const { location } = useHistory();
  const { data: noteficaionData } = useSse(
    `/notification/sse/${decode?.userId}`
  );
  const contentNotif = (
    <Row justify="center" gutter={[0, 10]} align="middle">
      {noteficaionData?.length ? (
        noteficaionData
          ?.filter((item: any) => !notificationReadIds?.includes(item.id))
          .map(({ message, id, link }: any) => (
            <>
              <Col span={24}>
                <Card>
                  <Row justify="space-between" gutter={[10, 0]} align="middle">
                    <Col span={20}>
                      {link ? (
                        <ToolTipC placement="right" title={t("محل اعلان")}>
                          <Typography.Link
                            style={{ color: "#4c4c4c" }}
                            href={`${window.location.origin}${link}`}
                            target="_blank"
                          >
                            {message}
                          </Typography.Link>
                        </ToolTipC>
                      ) : (
                        message
                      )}
                    </Col>
                    <Col span={2}>
                      <Row gutter={[0, 20]}>
                        <Col span={24}>
                          {" "}
                          <ToolTipC
                            placement="right"
                            title={t("add to readings")}
                          >
                            <IconC
                              onClick={() => {
                                onEdit(`/notification/isRead/${id}`).then(() =>
                                  setNotificationReadIds((old) => [...old, id])
                                );
                              }}
                              type="CheckCircleOutlined"
                              style={{ color: "#ffca00", fontSize: "20px" }}
                            />
                          </ToolTipC>
                        </Col>
                        <Col span={24}>
                          {" "}
                          <ToolTipC
                            placement="right"
                            title={t("حذف از لیست برای همه")}
                          >
                            <IconC
                              onClick={() => {
                                onEdit(`/notification/resolve/${id}`).then(() =>
                                  setNotificationReadIds((old) => [...old, id])
                                );
                              }}
                              type="DeleteOutlined"
                              style={{ color: "red", fontSize: "20px" }}
                            />
                          </ToolTipC>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Card>
              </Col>
            </>
          ))
      ) : (
        <EmptyC />
      )}
    </Row>
  );

  return (
    <>
      <div
        style={{ cursor: "pointer" }}
        onClick={() => setVisible(true)}
        className="notific"
      >
        <span>
          <Badge
            count={
              noteficaionData?.filter(
                (item: any) => !notificationReadIds?.includes(item.id)
              )?.length
            }
            offset={[17, -2]}
            size="small"
          >
            <img src={bell} style={{ ...styler({ marginLeft: "7px" }) }} />
          </Badge>
        </span>
        <span>{t("notifications")}</span>
      </div>
      <Drawer
        title={t("notifications")}
        placement={"left"}
        width={500}
        onClose={() => setVisible(false)}
        visible={visible}
      >
        {contentNotif}
      </Drawer>
    </>
  );
};

export default NotificationsHeader;
